export function isMobileBrowser() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

/**
 * @param data - array of Contents data, see https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#listObjectsV2-property 
 */
export function s3ToJsonDirStructure( data ) {
    let entries = data.Contents.map( item => {
        return { 
            key: item.Key, 
            lastModified: item.LastModified //TODO:: replace with latest log
        }
    })

    // Turn everything into a list of strings
    let pathsInBucket = entries.map( item => item.key );

    const addPathToJson = ( json, path ) => {
        let bits = path.split('/');
        let currJson = json

        for( let i = 0; i < bits.length; i++ ) {
            let bit = bits[i];

            if( bit.length === 0 ) {
                // Save metadata for directories
                let details = entries.find( item => item.key === path)
                if( details ) {
                    currJson['metadata'] = {
                        key: details.key,
                    }
                }
                continue    
            }

            if( !Object.keys(currJson)?.includes(bit) ) {
                currJson[bit] = {}
                let folderName = path.substr(0, path.lastIndexOf(bit))
                if( !Object.keys(currJson).includes('metadata') ) {
                    currJson['metadata'] = {
                        key: folderName,
                    }
                }
            }
            
            currJson = currJson[bit];
        }

    }

    let json = {};

    for( let path of pathsInBucket ) {
        addPathToJson( json, path )
    }

    console.log("created json structure")
    console.log('json :', json)

    return json;
}

/**
 * 
 * @param {*} s3Time - eg '2022-10-02T10:21:20.000Z'
 * @returns Date object
 */

export function parseS3TimeString( s3Time ) {
    // 2022-10-02T10:21:20.000Z
    let bits = s3Time.split('T')
    let dateSection = bits[0]
    let timeSection = bits[1].split('Z')[0]

    let dateBits = dateSection.split('-')
    let year = dateBits[0]
    let month = dateBits[1]
    let day = dateBits[2]

    let timeBits = timeSection.split(':')
    let hours = timeBits[0]
    let minutes = timeBits[1]
    let seconds = timeBits[2].split('.')[0]
    let millis = timeBits[2].split('.')[1]

    let outputDate = new Date(year, month - 1, day, hours, minutes, seconds)

    return outputDate;

}

export function parseFilenameFromKey( key ) {
    // Expecting "logs/multi-test/berlin/log_2022-10-17T19:01:50.txt"
    try {
        let filename = key.split('/')[3]
        return filename
    }
    catch( err ) {
        console.error('Failed to parse filename from key!')
        console.error(err)
    }
}

/**
 * 
 * @param {string} key - eg. "logs/multi-test/berlin/log_2022-10-17T19:01:50.txt" 
 * @returns {string} the date part - eg. "2022-10-17"
 */
export function parseDateFromKey( key ) {
    try {
        let filename = key.split('/')[3]
        let dateStr = filename.substring(0, filename.indexOf('.txt'))
    
        let dateBit = dateStr.substring( dateStr.indexOf('_') + 1, dateStr.indexOf('T'))
        let timeBit = dateStr.substring( dateStr.indexOf('T') + 1 )

        return dateBit
    }
    catch ( err ) {
        console.error('Failed to parse date from key!')
        console.error(err)
    }
}

/**
 * 
 * @param {string} key - eg. "logs/multi-test/berlin/log_2022-10-17T19:01:50.txt" 
 * @returns {string} the time part - eg. "19:01:50"
 */
export function parseTimeFromKey( key ) {
    try {
        let filename = key.split('/')[3]
        let dateStr = filename.substring(0, filename.indexOf('.txt'))
    
        let timeBit = dateStr.substring( dateStr.indexOf('T') + 1 )

        return timeBit
    }
    catch ( err ) {
        console.error('Failed to parse time from key!')
        console.error(err)
    }
}

/**
 * 
* @param {string} key - eg. "logs/multi-test/berlin/log_2022-10-17T19:01:50.txt" 
 * @returns { company: ... , location: ...}
 */
export function parseDetailsFromKey(key) {
    let res = key.split("/");
    let out = {};
    out.company = res[1];
    out.location = res[2];

    return out;
}

/**
 * 
 * @param {*} json 
 * @param {*} path
 * @param {*} closure 
 */
export function findKeyInJson( json, path, closure, depth = 0 ) {
    let keys = Object.keys(json)

    let results = [];

    if( depth > 6 ) {
        console.log('max depth reached!')
        return
    }
    
    for( let i = 0; i < keys.length; i++ ) {
        let key = keys[i]
        if( closure(key) ) {
            let fullPath = path.length > 0 ? path + '/' + key : key
            results.push( fullPath)
        }
        else {
            if( !(typeof json[key] === 'string') && Object.keys( json[key] ) ) {
                let nextPath = path + "/" + key
                results = [ ...results, ...findKeyInJson( json[key], nextPath, closure, depth+1 ) ]
            }
        }
    }
    return results

}